import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
 import ReportsTabs from "../Reports/ReportsTab";

const SupplierPayableReport = () => {
  const { user, loading } = useAuth();

  // --- Date Helpers ---
  const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    const localDate = new Date(today.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const getFirstDayOfMonth = () => {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const offset = firstDay.getTimezoneOffset();
    const localDate = new Date(firstDay.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  // --- State Management ---
  const [pageLoading, setPageLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [expandedSuppliers, setExpandedSuppliers] = useState(new Set());

  // Filter States
  const [fromDate, setFromDate] = useState(getFirstDayOfMonth());
  const [toDate, setToDate] = useState(getTodayDate());
  const [includeChildCompanies, setIncludeChildCompanies] = useState(true);

  // Summary Stats
  const [summaryStats, setSummaryStats] = useState({
    totalPayable: 0,
    totalCollected: 0,
    totalCommission: 0,
    totalSuppliers: 0,
    totalBookings: 0
  });

  // // --- API Call ---
  // const GetData = async (overrideParams = null) => {
  //   if (!user?.cid) return;

  //   setPageLoading(true);

  //   const requestPayload = overrideParams || {
  //     companyId: user.cid,
  //     fromDate: fromDate || null,
  //     toDate: toDate || null,
  //     includeChildCompanies: includeChildCompanies
  //   };

  //   console.log("Supplier Payable Request Payload:", requestPayload);

  //   try {
  //     const res = await apiService.getAll(
  //       config.GETSUPPLIERPAYABLEREPORT,
  //       requestPayload
  //     );

  //     if (res && res.succeeded && res.data) {
  //       setReportData(res.data);
        
  //       // Calculate summary statistics
  //       const suppliers = res.data.supplierReports || [];
  //       const totalBookings = suppliers.reduce((sum, s) => sum + s.totalBookings, 0);
        
  //       setSummaryStats({
  //         totalPayable: res.data.grandTotalPayable || 0,
  //         totalCollected: res.data.grandTotalCollected || 0,
  //         totalCommission: res.data.grandTotalCommission || 0,
  //         totalSuppliers: suppliers.length,
  //         totalBookings: totalBookings
  //       });
  //     } else {
  //       setReportData(null);
  //       setSummaryStats({
  //         totalPayable: 0,
  //         totalCollected: 0,
  //         totalCommission: 0,
  //         totalSuppliers: 0,
  //         totalBookings: 0
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch supplier payable report:", error);
  //     setReportData(null);
  //     setSummaryStats({
  //       totalPayable: 0,
  //       totalCollected: 0,
  //       totalCommission: 0,
  //       totalSuppliers: 0,
  //       totalBookings: 0
  //     });
  //   } finally {
  //     setPageLoading(false);
  //   }
  // };
// --- API Call ---
const GetData = async (overrideParams = null) => {
  if (!user?.cid) return;

  setPageLoading(true);

  const params = overrideParams || {
    companyId: user.cid,
    fromDate: fromDate || null,
    toDate: toDate || null,
    includeChildCompanies: includeChildCompanies
  };

  console.log("Supplier Payable Request Params:", params);

  try {
    // Build query string
    const queryParams = new URLSearchParams();
    if (params.companyId) queryParams.append('companyId', params.companyId);
    if (params.fromDate) queryParams.append('fromDate', params.fromDate);
    if (params.toDate) queryParams.append('toDate', params.toDate);
    if (params.includeChildCompanies !== undefined) queryParams.append('includeChildCompanies', params.includeChildCompanies);
    
    const url = `${config.GETSUPPLIERPAYABLEREPORT}?${queryParams.toString()}`;
    
    // If your apiService.getAll expects URL and params differently
    const res = await apiService.getAll(url); // or use apiService.get() if available
    
    // Alternative: If apiService expects config object
    // const res = await apiService.getAll({
    //   url: config.GETSUPPLIERPAYABLEREPORT,
    //   params: queryParams
    // });

    if (res && res.succeeded && res.data) {
      setReportData(res.data);
      
      // Calculate summary statistics
      const suppliers = res.data.supplierReports || [];
      const totalBookings = suppliers.reduce((sum, s) => sum + s.totalBookings, 0);
      
      setSummaryStats({
        totalPayable: res.data.grandTotalPayable || 0,
        totalCollected: res.data.grandTotalCollected || 0,
        totalCommission: res.data.grandTotalCommission || 0,
        totalSuppliers: suppliers.length,
        totalBookings: totalBookings
      });
    } else {
      setReportData(null);
      setSummaryStats({
        totalPayable: 0,
        totalCollected: 0,
        totalCommission: 0,
        totalSuppliers: 0,
        totalBookings: 0
      });
    }
  } catch (error) {
    console.error("Failed to fetch supplier payable report:", error);
    setReportData(null);
    setSummaryStats({
      totalPayable: 0,
      totalCollected: 0,
      totalCommission: 0,
      totalSuppliers: 0,
      totalBookings: 0
    });
  } finally {
    setPageLoading(false);
  }
};
  // --- Handlers ---
  const handleReset = () => {
    const defaultFrom = getFirstDayOfMonth();
    const defaultTo = getTodayDate();

    setFromDate(defaultFrom);
    setToDate(defaultTo);
    setIncludeChildCompanies(true);
    setExpandedSuppliers(new Set());

    GetData({
      companyId: user.cid,
      fromDate: defaultFrom,
      toDate: defaultTo,
      includeChildCompanies: true
    });
  };

  const toggleSupplierExpand = (supplierId) => {
    setExpandedSuppliers(prev => {
      const newSet = new Set(prev);
      if (newSet.has(supplierId)) {
        newSet.delete(supplierId);
      } else {
        newSet.add(supplierId);
      }
      return newSet;
    });
  };

  const viewBookingDetails = (supplier) => {
    setSelectedSupplier(supplier);
    setShowBookingModal(true);
  };

  const closeModal = () => {
    setShowBookingModal(false);
    setSelectedSupplier(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // Initial Load
  useEffect(() => {
    if (user && !loading) {
      GetData();
    }
  }, [user, loading]);

  if (loading) return <p>Loading user data...</p>;

  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection={"reports"} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <ReportsTabs pageName="SUPPLIER PAYABLE REPORT" />
                </div>

                <div className="card-body">
                  {/* --- Summary Cards --- */}
                  {!pageLoading && reportData && (
                    <div className="row mb-4 g-3">
                      <div className="col-md-3">
                        <div className="card bg-primary bg-gradient text-white">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6 className="mb-1">Total Payable to Suppliers</h6>
                                <h3 className="mb-0">{formatCurrency(summaryStats.totalPayable)}</h3>
                              </div>
                              <i className="ri-wallet-3-line fs-1"></i>
                            </div>
                            <small className="mt-2 d-block">Amount to be paid to all suppliers</small>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-3">
                        <div className="card bg-success bg-gradient text-white">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6 className="mb-1">Total Collected</h6>
                                <h3 className="mb-0">{formatCurrency(summaryStats.totalCollected)}</h3>
                              </div>
                              <i className="ri-bank-card-line fs-1"></i>
                            </div>
                            <small className="mt-2 d-block">Amount collected from customers</small>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-3">
                        <div className="card bg-info bg-gradient text-white">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6 className="mb-1">Total Commission Earned</h6>
                                <h3 className="mb-0">{formatCurrency(summaryStats.totalCommission)}</h3>
                              </div>
                              <i className="ri-money-rupee-circle-line fs-1"></i>
                            </div>
                            <small className="mt-2 d-block">Your profit margin</small>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-3">
                        <div className="card bg-warning bg-gradient text-dark">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6 className="mb-1">Margin %</h6>
                                <h3 className="mb-0">
                                  {summaryStats.totalCollected > 0 
                                    ? ((summaryStats.totalCommission / summaryStats.totalCollected) * 100).toFixed(2)
                                    : 0}%
                                </h3>
                              </div>
                              <i className="ri-percent-line fs-1"></i>
                            </div>
                            <small className="mt-2 d-block">Overall profit margin</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* --- Filter Section --- */}
                  <div className="row mb-4 g-3">
                    {/* From Date */}
                    <div className="col-md-3">
                      <label className="form-label">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>

                    {/* To Date */}
                    <div className="col-md-3">
                      <label className="form-label">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>

                    {/* Include Child Companies */}
                    <div className="col-md-3">
                      <label className="form-label">Company Scope</label>
                      <select
                        className="form-select"
                        value={includeChildCompanies}
                        onChange={(e) => setIncludeChildCompanies(e.target.value === "true")}
                      >
                        <option value="true">Include Child Companies</option>
                        <option value="false">Current Company Only</option>
                      </select>
                    </div>

                    {/* Buttons */}
                    <div className="col-md-3 d-flex align-items-end">
                      <button
                        className="btn btn-primary me-2 flex-grow-1"
                        onClick={() => GetData(null)}
                      >
                        <i className="ri-search-line align-bottom me-1"></i> Search
                      </button>

                      <button
                        className="btn btn-danger"
                        onClick={handleReset}
                      >
                        <i className="ri-refresh-line align-bottom me-1"></i> Reset
                      </button>
                    </div>
                  </div>

                  {/* --- Company Info Header --- */}
                  {!pageLoading && reportData && (
                    <div className="alert alert-info alert-label-icon label-arrow fade show mb-3">
                      <i className="ri-information-line label-icon"></i>
                      <strong>{reportData.companyName}</strong> - Report Period: {formatDate(reportData.fromDate)} to {formatDate(reportData.toDate)}
                      {includeChildCompanies && <span className="ms-2 badge bg-info">Including Child Companies</span>}
                    </div>
                  )}

                  {/* --- Supplier Table Section --- */}
                  <div className="table-responsive table-card p-2">
                    <table
                      className="table align-middle table-striped table-hover"
                      id="supplierPayableTable"
                    >
                      <thead className="bg-soft-info bg-gradient">
                        <tr>
                          <th style={{ width: "50px" }}>#</th>
                          <th>Supplier Name</th>
                          <th>Brand Name</th>
                          <th className="text-center">Total Bookings</th>
                          <th className="text-end">Payable Amount</th>
                          <th className="text-end">Collected Amount</th>
                          <th className="text-end">Commission</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      
                      {pageLoading ? (
                        <tbody>
                          <tr>
                            <td colSpan="8" className="text-center">
                              <img
                                src="/assets/images/loader.webp"
                                width="64px"
                                height="64px"
                                alt="Loading..."
                              />
                              <p>Loading Report, Please wait...</p>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <>
                          <tbody className="list form-check-all">
                            {reportData && reportData.supplierReports && reportData.supplierReports.length > 0 ? (
                              reportData.supplierReports.map((supplier, index) => (
                                <React.Fragment key={supplier.supplierId}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-sm btn-link p-0 me-2"
                                          onClick={() => toggleSupplierExpand(supplier.supplierId)}
                                        >
                                          <i className={`ri-${expandedSuppliers.has(supplier.supplierId) ? 'arrow-down-s-line' : 'arrow-right-s-line'} fs-5`}></i>
                                        </button>
                                        <strong>{supplier.supplierName}</strong>
                                      </div>
                                    </td>
                                    <td>{supplier.brandName || "-"}</td>
                                    <td className="text-center">
                                      <span className="badge bg-info">
                                        {supplier.totalBookings}
                                      </span>
                                    </td>
                                    <td className="text-end fw-bold text-danger">
                                      {formatCurrency(supplier.totalPayableAmount)}
                                    </td>
                                    <td className="text-end text-success">
                                      {formatCurrency(supplier.totalCollectedAmount)}
                                    </td>
                                    <td className="text-end fw-bold text-primary">
                                      {formatCurrency(supplier.totalCommission)}
                                    </td>
                                    <td className="text-center">
                                      <button
                                        className="btn btn-sm btn-outline-info"
                                        onClick={() => viewBookingDetails(supplier)}
                                      >
                                        <i className="ri-eye-line me-1"></i> View Bookings
                                      </button>
                                    </td>
                                  </tr>
                                  
                                  {/* Expanded Bookings Row */}
                                  {expandedSuppliers.has(supplier.supplierId) && supplier.bookings && (
                                    <tr>
                                      <td colSpan="8" className="p-0">
                                        <div className="bg-light p-3 m-2 rounded">
                                          <h6 className="mb-3">Booking Details - {supplier.supplierName}</h6>
                                          <div className="table-responsive">
                                            <table className="table table-sm table-bordered">
                                              <thead className="bg-secondary bg-gradient text-white">
                                                <tr>
                                                  <th>Booking No</th>
                                                  <th>PNR</th>
                                                  <th>Passenger Name</th>
                                                  <th>Booking Date</th>
                                                  <th>Departure Date</th>
                                                  <th>Status</th>
                                                  <th className="text-end">Payable</th>
                                                  <th className="text-end">Collected</th>
                                                  <th className="text-end">Commission</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {supplier.bookings.map((booking, idx) => (
                                                  <tr key={booking.flightBookingId}>
                                                    <td>{booking.bookingNo}</td>
                                                    <td>{booking.pnr || "-"}</td>
                                                    <td>{booking.travellerName || "-"}</td>
                                                    <td>{formatDate(booking.bookingDate)}</td>
                                                    <td>{formatDate(booking.departureDate)}</td>
                                                    <td>
                                                      <span className={`badge bg-${booking.bookingStatus === 'CONFIRMED' ? 'success' : 'warning'}`}>
                                                        {booking.bookingStatus}
                                                      </span>
                                                    </td>
                                                    <td className="text-end text-danger">
                                                      {formatCurrency(booking.payableToSupplier)}
                                                    </td>
                                                    <td className="text-end text-success">
                                                      {formatCurrency(booking.collectedFromCustomer)}
                                                    </td>
                                                    <td className="text-end text-primary">
                                                      {formatCurrency(booking.commission)}
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                              <tfoot className="bg-light">
                                                <tr>
                                                  <td colSpan="6" className="text-end fw-bold">Total:</td>
                                                  <td className="text-end fw-bold text-danger">
                                                    {formatCurrency(supplier.totalPayableAmount)}
                                                  </td>
                                                  <td className="text-end fw-bold text-success">
                                                    {formatCurrency(supplier.totalCollectedAmount)}
                                                  </td>
                                                  <td className="text-end fw-bold text-primary">
                                                    {formatCurrency(supplier.totalCommission)}
                                                  </td>
                                                </tr>
                                              </tfoot>
                                            </table>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  <div className="py-5">
                                    <i className="ri-inbox-line fs-1 text-muted"></i>
                                    <p className="mt-2">No supplier payable records found for the selected period.</p>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                          
                          {/* Grand Total Footer */}
                          {reportData && reportData.supplierReports && reportData.supplierReports.length > 0 && (
                            <tfoot className="bg-soft-dark">
                              <tr>
                                <td colSpan="4" className="text-end fw-bold fs-14">
                                  GRAND TOTAL:
                                </td>
                                <td className="text-end fw-bold fs-14 text-danger">
                                  {formatCurrency(reportData.grandTotalPayable)}
                                </td>
                                <td className="text-end fw-bold fs-14 text-success">
                                  {formatCurrency(reportData.grandTotalCollected)}
                                </td>
                                <td className="text-end fw-bold fs-14 text-primary">
                                  {formatCurrency(reportData.grandTotalCommission)}
                                </td>
                                <td></td>
                              </tr>
                            </tfoot>
                          )}
                        </>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- Booking Details Modal --- */}
      {showBookingModal && selectedSupplier && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  <i className="ri-flight-takeoff-line me-2"></i>
                  Booking Details - {selectedSupplier.supplierName}
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="card bg-light">
                      <div className="card-body text-center">
                        <h6>Total Bookings</h6>
                        <h3 className="text-primary">{selectedSupplier.totalBookings}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card bg-light">
                      <div className="card-body text-center">
                        <h6>Total Payable</h6>
                        <h3 className="text-danger">{formatCurrency(selectedSupplier.totalPayableAmount)}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card bg-light">
                      <div className="card-body text-center">
                        <h6>Total Commission</h6>
                        <h3 className="text-success">{formatCurrency(selectedSupplier.totalCommission)}</h3>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead className="bg-secondary bg-gradient text-white">
                      <tr>
                        <th>S.No</th>
                        <th>Booking No</th>
                        <th>PNR</th>
                        <th>Passenger Name</th>
                        <th>Booking Date</th>
                        <th>Departure Date</th>
                        <th>Status</th>
                        <th className="text-end">Payable</th>
                        <th className="text-end">Collected</th>
                        <th className="text-end">Commission</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedSupplier.bookings.map((booking, idx) => (
                        <tr key={booking.flightBookingId}>
                          <td>{idx + 1}</td>
                          <td>
                            <strong>{booking.bookingNo}</strong>
                          </td>
                          <td>{booking.pnr || "-"}</td>
                          <td>{booking.travellerName || "-"}</td>
                          <td>{formatDate(booking.bookingDate)}</td>
                          <td>{formatDate(booking.departureDate)}</td>
                          <td>
                            <span className={`badge bg-${booking.bookingStatus === 'CONFIRMED' ? 'success' : 'warning'}`}>
                              {booking.bookingStatus}
                            </span>
                          </td>
                          <td className="text-end text-danger">
                            {formatCurrency(booking.payableToSupplier)}
                          </td>
                          <td className="text-end text-success">
                            {formatCurrency(booking.collectedFromCustomer)}
                          </td>
                          <td className="text-end text-primary">
                            {formatCurrency(booking.commission)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="bg-light">
                      <tr>
                        <td colSpan="7" className="text-end fw-bold">Total:</td>
                        <td className="text-end fw-bold text-danger">
                          {formatCurrency(selectedSupplier.totalPayableAmount)}
                        </td>
                        <td className="text-end fw-bold text-success">
                          {formatCurrency(selectedSupplier.totalCollectedAmount)}
                        </td>
                        <td className="text-end fw-bold text-primary">
                          {formatCurrency(selectedSupplier.totalCommission)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  <i className="ri-close-line me-1"></i> Close
                </button>
                <button type="button" className="btn btn-primary" onClick={() => window.print()}>
                  <i className="ri-printer-line me-1"></i> Print
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplierPayableReport;